import axios from 'axios';

async function fetchData(url, method = 'GET', data = null, headers = {},noAuth = ()=>{}) {
  const authToken = localStorage.getItem('AUTH_TOKEN');
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  try {
    const response = await axios({
      url,
      method,
      data,
      headers,
    });

    return response.data;
  } catch (err) {
    if (err.response && err.response.status === 401) {
        noAuth();
    }else{
      throw err;
    }

    
  }
}

export default fetchData;
